import { render } from "./AutoVerificationServices.vue?vue&type=template&id=5acc58b2&scoped=true"
import script from "./AutoVerificationServices.vue?vue&type=script&lang=js"
export * from "./AutoVerificationServices.vue?vue&type=script&lang=js"

import "./AutoVerificationServices.vue?vue&type=style&index=0&id=5acc58b2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5acc58b2"]])

export default __exports__